<script>
import {getListBackup} from "@/api/log-api";
import {mixin_clearPhoneNumShow, mixin_page_table} from "@/utils/mixin";

export default {
  name: "BackupLogPage",
  mixins: [mixin_page_table, mixin_clearPhoneNumShow],
  data() {
    return {
      tableHeader: [
        {prop: 'id', label: '序号', width: 100, type: 0},
        {prop: 'type', label: '操作类型', width: 100, type: 3},
        // {prop: 'execDay', label: '执行日期', width: 100, type: 0},
        {prop: 'execResult', label: '执行结果', width: "", type: 2},
        {prop: 'beginTime', label: '开始时间', width: 200, type: 1},
        {prop: 'endTime', label: '结束时间', width: 200, type: 1},
        // {prop: 'fileName', label: '文件名', width: '', type: 0},

      ],
    }
  },
  filters: {
    formatTime0(time) {
      const date = new Date(time);
      const year = date.getFullYear().toString().slice(-2);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    formatResult(result) {
      switch (result) {
        case "SUCCESS":
          return "执行成功"
        case "FAIL":
        default:
          return "执行失败"
      }
    },
    formatType(result) {
      switch (result) {
        case "CLEAR_RECORD":
          return "清除记录"
        case "DATA_BACKUP":
          return "数据备份"
        default:
          return result
      }
    }
  },
  mounted() {
    this.refreshTableData()
  },

  methods: {
    refreshTableData() {
      this.tableData = []
      let pageIndex = this.curPageIndex
      let pageSize = this.curPageSize
      getListBackup(pageIndex, pageSize).then(({data}) => {
        console.log("getListBackup", data)
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals

        } else {
          this.$message.error(data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log(err)
        this.showNetErrMsg()
      })
    },
  }
}
</script>

<template>
  <div>
    <div>
      <div style="margin-bottom: 10px"></div>
      <el-table :data="tableData" border>
        <el-table-column v-for="(headerItem) in tableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                         :width="headerItem.width" :label="headerItem.label">
          <template v-slot="scope">
            <template v-if="headerItem.type === 1">{{ scope.row[headerItem.prop] | formatTime0 }}</template>
            <template v-else-if="headerItem.type ===2">
              <el-tag>{{ scope.row[headerItem.prop] | formatResult }}</el-tag>
            </template>
            <template v-else-if="headerItem.type ===3">
              <el-tag>{{ scope.row[headerItem.prop] | formatType }}</el-tag>
            </template>
            <template v-else-if="headerItem.type === 9">
              <template v-if="phoneNumShow">{{ scope.row[headerItem.prop] }}</template>
              <template v-else>{{ scope.row[headerItem.prop] | phNoFilter }}</template>
            </template>
            <template v-else>{{ scope.row[headerItem.prop] }}</template>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination layout="sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                       :page-size.sync="curPageSize" :pager-count="5"
                       :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.el-table {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
